/* =============================================================================
   custom-size-transom.js — R21.2 (OPTIS / checkbox, fill Remark only)
   - 位置：同組「Custom Size」checkbox 之後（或 #custom-size-anchor）
   - 判斷：寬優先→高次之 最小覆蓋(ceil)，自動帶 -2/-3/-4
   - 輸入/Apply：把「Custom Size: W" x H"（含 ft+in 顯示）」寫入最下方 Remark/備註欄位
   - 修正：當超出範圍時「不顯示 Applied price size」，清空 Applied Price Size，並停用 Apply
   - ★ NEW(重要)：
       (1) 防止年份/雜訊(例如 2025)被誤判成 Door Size code：Snapshot 只接受「真的出現在 Door Size 選項附近」的 codes
       (2) 當客製尺寸小於最小標準尺寸時：直接套用最小標準尺寸價格（例如 2610）
   ============================================================================= */
(function(){
  if (window.__TRANSOM_OPTIS_R212__) return; window.__TRANSOM_OPTIS_R212__=true;

  // ---- 規格限制（依 Lite）----
  const LIMITS = {
    1:{minW:12,maxW:72,minH:12,maxH:24},
    2:{minW:60,maxW:96,minH:12,maxH:24},
    3:{minW:90,maxW:144,minH:12,maxH:24},
    4:{minW:120,maxW:144,minH:12,maxH:24},
  };

  // ---- 小工具 ----
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const TXT=el=>(el?.innerText||el?.textContent||'').trim();
  const cssEscape=s=>window.CSS?.escape?CSS.escape(s):String(s).replace(/[^a-zA-Z0-9_\-\[\]]/g,'_');
  const toFi=v=>{const f=Math.floor(v/12),i=Math.round((v-f*12)*100)/100;return `${f}' ${i}"`;};
  const suf=lite=>lite===2?'-2':lite===3?'-3':lite===4?'-4':'';

  // ---- 定位 Custom Size 那一組 ----
  const isCustomText = s => /\bcustom\s*-?\s*size\b/i.test(String(s||'').replace(/[．。:\：]/g,' ')) ||
                             /\bcustom\s*-?\s*dimension(s)?\b/i.test(String(s||'')) ||
                             ['自訂尺寸','自定義尺寸','客製尺寸','客製化尺寸'].some(k=>String(s||'').includes(k));
  function isCustomInput(inp){
    const lab = inp.id ? document.querySelector(`label[for="${inp.id}"]`) : inp.closest('label');
    const s = (lab && TXT(lab)) || inp.getAttribute('aria-label') || inp.value || '';
    if (isCustomText(s)) return true;
    const v=(inp.getAttribute('data-tier-code')||'')+(inp.getAttribute('data-value')||'')+(inp.name||'');
    return /custom/i.test(v);
  }
  function findAllDoorSets(){
    const customs = $$('input[type="checkbox"],input[type="radio"]').filter(isCustomInput);
    const out=[];
    customs.forEach(custom=>{
      const group = custom.closest('[data-bss-option], fieldset, .bss-po-group, .product-option, .product-form__input') || custom.closest('div,section,fieldset') || document.body;
      const name  = custom.name;
      const set   = name ? $$(`input[name="${cssEscape(name)}"]`, group) : [custom];
      if (set.length) out.push({group,set,custom,name});
    });
    return out;
  }
  const getSelectedCustomSet = ()=> findAllDoorSets().find(s=>s.custom?.checked) || null;

  // ---- 解析碼 / 快照 / 判斷 ----
  function parseCode(str){
    const s=String(str||'').replace(/\s+/g,'').toUpperCase();
    let m=s.match(/(^|\D)(\d{3})(\d{2})(?:-\d+)?(\D|$)/);
    if(m){
      const W=+m[2],H=+m[3];
      return {code:`${m[2]}${m[3]}`, wIn:Math.floor(W/10)*12+(W%10), hIn:Math.floor(H/10)*12+(H%10)};
    }
    m=s.match(/(^|\D)(\d{2})(\d{2})(\D|$)/);
    if(m){
      const W=+m[2],H=+m[3];
      return {code:`${m[2]}${m[3]}`, wIn:Math.floor(W/10)*12+(W%10), hIn:Math.floor(H/10)*12+(H%10)};
    }
    return null;
  }
  function harvestTextsAroundInput(inp, scope){
    const texts=[], push=t=>{ if(t && t.length<=48) texts.push(t); };
    const lab = inp.id ? scope.querySelector(`label[for="${inp.id}"]`) : inp.closest('label');
    if (lab){
      push(TXT(lab));
      ['data-tier-code','data-value','data-option-label','data-po-value','data-bsspo','data-code'].forEach(k=>lab.hasAttribute(k)&&push(lab.getAttribute(k)));
    }
    ['value','data-tier-code','data-value','aria-label','data-code','data-po-value'].forEach(k=> inp.hasAttribute(k)&&push(inp.getAttribute(k)));
    const wrap = inp.closest('[data-tier-code],[data-value],[data-code]');
    if (wrap) ['data-tier-code','data-value','data-code'].forEach(k=> wrap.hasAttribute(k)&&push(wrap.getAttribute(k)));
    if (inp.nextElementSibling) push(TXT(inp.nextElementSibling));
    if (inp.parentElement) push(TXT(inp.parentElement));
    return texts.filter(Boolean);
  }

  // ★ NEW: 從「真正的 Door Size 選項 input 周邊」建立允許 codes，避免 2025 之類雜訊被當成尺寸碼
  function collectSnapshot(inputs, scope){
    const map=new Map();
    const allowed=new Set();

    // 1) 先只從每個選項 input 周邊收集 code（最可信）
    inputs.forEach(inp=>{
      if (isCustomInput(inp)) return;
      harvestTextsAroundInput(inp, scope).forEach(t=>{
        const p=parseCode(t);
        if(p){
          allowed.add(p.code);
          if(!map.has(p.code)) map.set(p.code,p);
        }
      });
    });

    // 2) 若 allowed 有內容，後續掃描一律「只接受 allowed 內的 code」避免抓到年份 2025 等
    const gate = (p)=> (allowed.size ? allowed.has(p.code) : true);

    $$('[data-tier-code],[data-value],[data-code]', scope).forEach(n=>{
      ['data-tier-code','data-value','data-code'].forEach(k=>{
        if(n.hasAttribute(k)){
          const p=parseCode(n.getAttribute(k));
          if(p && gate(p) && !map.has(p.code)) map.set(p.code,p);
        }
      });
    });

    $$('label, span, div, p, td, th, dd', scope).forEach(n=>{
      const t=TXT(n); if(!t || t.length>40) return;
      const p=parseCode(t);
      if(p && gate(p) && !map.has(p.code)) map.set(p.code,p);
    });

    const list=Array.from(map.values());
    list.sort((a,b)=> (a.wIn-b.wIn) || (a.hIn-b.hIn));
    return list;
  }

  function buildSnapshotForSet(set, group, name){
    const snap1 = collectSnapshot(set, group);
    if (snap1.length) return snap1;
    const setGlobal = name ? $$(`input[name="${cssEscape(name)}"]`, document.body) : set;
    return collectSnapshot(setGlobal, document.body);
  }

  function inferLite(snap){
    const pool=[ $('h1')?.innerText, $('.product__title')?.innerText, document.title ].filter(Boolean).join(' ');
    let m=pool.match(/(^|\D)([1-4])\s*[- ]*Lite\b/i);
    if (m) return +m[2];
    if (snap && snap.length){
      const minW=Math.min(...snap.map(o=>o.wIn));
      if (minW>=120) return 4;
      if (minW>=90)  return 3;
      if (minW>=60)  return 2;
      return 1;
    }
    return 1;
  }

  function pickTierWidthFirst(w,h,snap){
    if (!snap || !snap.length) return null;
    const widths=[...new Set(snap.filter(o=>o.wIn>=w).map(o=>o.wIn))].sort((a,b)=>a-b);
    for(const W of widths){
      const hs = snap.filter(o=>o.wIn===W && o.hIn>=h).map(o=>o.hIn).sort((a,b)=>a-b);
      if (hs.length){
        const H=hs[0];
        return snap.find(o=>o.wIn===W && o.hIn===H);
      }
    }
    return snap[snap.length-1] || null;
  }

  // ★ NEW: 取得最小標準尺寸（例如 2610）
  function getMinTier(snap){
    if (!snap || !snap.length) return null;
    const minW = Math.min(...snap.map(o=>o.wIn));
    const hs   = snap.filter(o=>o.wIn===minW).map(o=>o.hIn);
    const minH = hs.length ? Math.min(...hs) : Math.min(...snap.map(o=>o.hIn));
    const minObj = snap.find(o=>o.wIn===minW && o.hIn===minH) || snap[0];
    return {minW, minH, minObj};
  }

  function codeRegex(cand){
    const [d,tail]=cand.split('-');
    const digs=d.split('').map(c=>/\d/.test(c)?c:'').filter(Boolean).join('\\s*');
    const t=tail?`[\\-–—]?\\s*${tail}\\b`:'\\b';
    return new RegExp(`${digs}${t}`,'i');
  }

  function findInputByCode(codeBase, lite, group, set, name){
    const wants=[]; const s=suf(lite);
    if (s) wants.push(`${codeBase}${s}`); wants.push(codeBase);
    const scopes=[]; if(group) scopes.push(group); if(name) scopes.push(document.body);
    for (const cand of wants){
      const re=codeRegex(cand);
      for (const scope of scopes){
        let el = scope.querySelector(`[data-tier-code="${cand}"] input, [data-tier-code="${cand}"]`);
        if (!el) el = scope.querySelector(`[data-tier-code*="${cand}"] input, [data-tier-code*="${cand}"]`);
        if (!el) el = scope.querySelector(`[data-value="${cand}"] input, [data-value="${cand}"]`);
        if (!el) el = scope.querySelector(`[data-value*="${cand}"] input, [data-value*="${cand}"]`);
        if (el){
          const inp = el.tagName==='INPUT'?el:(el.querySelector('input[type="checkbox"],input[type="radio"]')||null);
          if (inp && (!name || inp.name===name)) return inp;
        }
        const lab = $$('label', scope).find(l=>re.test(TXT(l)));
        if (lab){
          if (lab.htmlFor){
            const inp=scope.querySelector('#'+lab.htmlFor);
            if (inp && (!name || inp.name===name)) return inp;
          }
          const inp = lab.querySelector('input[type="checkbox"],input[type="radio"]');
          if (inp && (!name || inp.name===name)) return inp;
        }
        const byVal = $$('input[type="checkbox"],input[type="radio"]', scope).find(i=> (!name || i.name===name) && re.test(String(i.value||'')));
        if (byVal) return byVal;
      }
    }
    return null;
  }

  // ---- Remark 欄位 ----
  function findRemarkField(){
    const candidates = [
      ...$$('textarea, input[type="text"]')
    ].filter(el=>{
      if (el.disabled) return false;
      if (!(el.offsetParent || el.getClientRects().length)) return false;
      const name=(el.getAttribute('name')||'').toLowerCase();
      const ph=(el.getAttribute('placeholder')||'').toLowerCase();
      const aria=(el.getAttribute('aria-label')||'').toLowerCase();
      const id=el.id;
      const lab = id ? document.querySelector(`label[for="${id}"]`) : el.closest('label');
      const labelTxt = (lab?TXT(lab):'').toLowerCase();
      const hit = /remark|備註|備考|備注|note|notes|message|留言/i;
      return hit.test(name) || hit.test(ph) || hit.test(aria) || hit.test(labelTxt);
    });
    if (!candidates.length) return null;
    return candidates[candidates.length-1];
  }
  function ensureHiddenRemark(form){
    let el = form?.querySelector('input[name="properties[Remark]"]');
    if (!el && form){
      el=document.createElement('input'); el.type='hidden'; el.name='properties[Remark]'; form.appendChild(el);
    }
    return el||null;
  }
  function fillRemark(text){
    const form=$('form[action*="/cart/add"]');
    const fld = findRemarkField();
    if (fld){
      fld.value = text;
      try{ fld.dispatchEvent(new Event('input',{bubbles:true})); fld.dispatchEvent(new Event('change',{bubbles:true})); }catch(_){}
      return true;
    }
    const hid = ensureHiddenRemark(form);
    if (hid){ hid.value=text; return true; }
    return false;
  }

  // ---- UI 盒 ----
  function ensureBox(){
    let box=document.getElementById('custom-size2-box');
    if (box) return box;
    box=document.createElement('div'); box.id='custom-size2-box';
    Object.assign(box.style,{margin:'10px 0',padding:'14px',border:'1px solid #e5e7eb',borderRadius:'12px',background:'#fafafa',display:'none'});
    box.innerHTML=`
      <div style="font-weight:700;margin-bottom:6px">Custom Size</div>
      <div style="font-size:12px;opacity:.85;margin-bottom:8px">Enter inches (up to two decimals). Will convert to ft + in.</div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 12px">
        <label style="display:flex;flex-direction:column">
          <span style="font-size:12px">Width (in.)</span>
          <input id="cs_w" type="number" step="0.01" min="0" placeholder="ex. 48.00" style="padding:10px;border:1px solid #d1d5db;border-radius:8px">
        </label>
        <label style="display:flex;flex-direction:column">
          <span style="font-size:12px">Height (in.)</span>
          <input id="cs_h" type="number" step="0.01" min="0" placeholder="ex. 16.00" style="padding:10px;border:1px solid #d1d5db;border-radius:8px">
        </label>
      </div>
      <div id="cs_conv"   style="font-size:12px;margin-top:6px"></div>
      <div id="cs_status" style="font-size:12px;margin-top:4px;color:#2563eb;font-weight:700"></div>
      <div id="cs_msg"    style="font-size:12px;font-weight:600;color:#d32f2f"></div>
      <div id="cs_range"  style="font-size:12px;color:#6b7280;margin-top:8px"></div>
      <div style="margin-top:10px"><button id="cs_apply" type="button" style="padding:8px 12px;border:1px solid #d1d5db;border-radius:8px;background:#fff;cursor:pointer">Apply</button></div>
    `;
    document.body.appendChild(box);
    return box;
  }
  function placeBox(box, group, customInput){
    const anchor = group?.querySelector('#custom-size-anchor, [data-custom-size-anchor]');
    if (anchor){ if (anchor.nextSibling!==box) anchor.insertAdjacentElement('afterend', box); return; }
    if (customInput){
      const lab = customInput.id ? group.querySelector(`label[for="${customInput.id}"]`) : customInput.closest('label');
      if (lab){ lab.insertAdjacentElement('afterend', box); return; }
    }
    if (group && group.nextSibling!==box) group.insertAdjacentElement('afterend', box);
  }

  // ---- Line item properties（備援）----
  function ensureProperty(form, key, val){
    let el = form?.querySelector(`input[name="properties[${key}]"]`);
    if (!el && form){ el=document.createElement('input'); el.type='hidden'; el.name=`properties[${key}]`; form.appendChild(el); }
    if (el) el.value = val;
    return el;
  }

  // ---- 計算 & 寫 Remark ----
  function compute(showErr=true){
    const box=ensureBox();
    const form=$('form[action*="/cart/add"]');
    const wI=$('#cs_w',box), hI=$('#cs_h',box),
          conv=$('#cs_conv',box), status=$('#cs_status',box),
          msg=$('#cs_msg',box), rng=$('#cs_range',box),
          applyBtn=$('#cs_apply',box);

    const sel=getSelectedCustomSet(); if(!sel) return {ok:false};
    const snap = buildSnapshotForSet(sel.set, sel.group, sel.name);
    const lite = inferLite(snap);
    const LIM = LIMITS[lite] || LIMITS[1];

    rng.textContent = `Accepted range — W: ${LIM.minW}–${LIM.maxW} in (${toFi(LIM.minW)}–${toFi(LIM.maxW)}), H: ${LIM.minH}–${LIM.maxH} in (${toFi(LIM.minH)}–${toFi(LIM.maxH)})`;

    const w=+wI.value, h=+hI.value;
    conv.textContent=(w>0&&h>0)?`Converted (ft + in): ${toFi(w)} × ${toFi(h)}`:'';
    if (!w||!h){
      if(showErr){msg.textContent='Please enter both width and height (in.).';}
      status.textContent=''; status.style.display='none';
      ensureProperty(form, 'Applied Price Size', '');
      if (applyBtn){ applyBtn.disabled=true; applyBtn.style.opacity='0.6'; applyBtn.style.cursor='not-allowed'; }
      return {ok:false};
    }

    const outOfRange=(w<LIM.minW||w>LIM.maxW||h<LIM.minH||h>LIM.maxH);
    msg.textContent = outOfRange ? `Out of acceptable range: W ${LIM.minW}–${LIM.maxW}, H ${LIM.minH}–${LIM.maxH}` : '';

    // ★ NEW: 低於「最小標準尺寸」時，價格判定要直接 clamp 到最小標準尺寸（例如 2610）
    let tier = null;
    if (!outOfRange){
      const minT = getMinTier(snap);
      const wEff = minT ? Math.max(w, minT.minW) : w;
      const hEff = minT ? Math.max(h, minT.minH) : h;
      tier = pickTierWidthFirst(wEff, hEff, snap) || (minT ? minT.minObj : null);
    }

    if (outOfRange){
      status.textContent='';
      status.style.display='none';
      ensureProperty(form, 'Applied Price Size', '');
      if (applyBtn){ applyBtn.disabled=true; applyBtn.style.opacity='0.6'; applyBtn.style.cursor='not-allowed'; }
    }else if (tier){
      status.style.display='';
      status.style.color = '#2563eb';
      status.textContent  = `Applied price size: ${tier.code}${suf(lite)} (≤ ${toFi(tier.wIn)} × ≤ ${toFi(tier.hIn)})`;
      ensureProperty(form, 'Applied Price Size', `${tier.code}${suf(lite)}`);
      if (applyBtn){ applyBtn.disabled=false; applyBtn.style.opacity='1'; applyBtn.style.cursor='pointer'; }
    }else{
      status.style.display='';
      status.style.color = '#d32f2f';
      status.textContent  = 'No matching Door Size option was found.';
      ensureProperty(form, 'Applied Price Size', '');
      if (applyBtn){ applyBtn.disabled=true; applyBtn.style.opacity='0.6'; applyBtn.style.cursor='not-allowed'; }
    }

    const labelIn  = `Custom Size: ${Number(w)}" x ${Number(h)}"`;
    const labelAll = `${labelIn} (${toFi(w)} x ${toFi(h)})`;
    fillRemark(labelAll);
    ensureProperty(form, 'Custom Size (in)', `${w}" x ${h}"`);
    ensureProperty(form, 'Custom Size (ft+in)', `${toFi(w)} x ${toFi(h)}`);

    return {ok:!outOfRange,w,h,tier,lite,group:sel.group,set:sel.set,name:sel.name,labelIn,labelAll};
  }

  // ---- Apply：清本組→勾對碼（不動其它群組），並再次填 Remark ----
  async function onApply(){
    const r=compute(true); if(!r.ok||!r.tier) return;
    r.set.filter(i=>i.checked).forEach(inp=>{
      const lb = inp.id ? document.querySelector(`label[for="${inp.id}"]`) : inp.closest('label');
      lb?.click?.(); inp.click?.(); inp.checked=false;
      inp.dispatchEvent(new Event('input',{bubbles:true}));
      inp.dispatchEvent(new Event('change',{bubbles:true}));
    });
    let target = findInputByCode(r.tier.code, r.lite, r.group, r.set, r.name);
    if(!target){
      for(let i=0;i<10 && !target;i++){
        await new Promise(res=>setTimeout(res,80));
        target = findInputByCode(r.tier.code, r.lite, r.group, r.set, r.name);
      }
    }
    if(!target){
      const box=ensureBox(); const msg=$('#cs_msg',box);
      msg.style.color='#f59e0b';
      msg.textContent=`Warning: matched option not found. (${r.tier.code}${suf(r.lite)})`;
      fillRemark(r.labelAll);
      return;
    }
    const lab = target.id ? document.querySelector(`label[for="${target.id}"]`) : target.closest('label');
    lab?.click?.(); target.click?.(); target.checked=true;
    target.dispatchEvent(new Event('input',{bubbles:true}));
    target.dispatchEvent(new Event('change',{bubbles:true}));
    fillRemark(r.labelAll);
    ensureBox().style.display='none';
  }

  // ---- 綁定 & 位置 ----
  function wireUI(){
    const box=ensureBox();
    $('#cs_apply',box)?.addEventListener('click', onApply);
    ['input','change','blur','keyup'].forEach(ev=>{
      $('#cs_w',box)?.addEventListener(ev, ()=>compute(false));
      $('#cs_h',box)?.addEventListener(ev, ()=>compute(false));
    });
  }
  function syncPlacement(){
    const box=ensureBox();
    const sel=getSelectedCustomSet();
    if (!sel){ box.style.display='none'; return; }
    placeBox(box, sel.group, sel.custom);
    box.style.display='';
    compute(false);
  }
  function attachDelegation(){
    const handler=()=>{ setTimeout(syncPlacement,0); };
    document.addEventListener('change', (e)=>{ if (e.target && (e.target.matches?.('input[type="checkbox"],input[type="radio"]'))) handler(); }, true);
    document.addEventListener('click',  (e)=>{ if (e.target && (e.target.matches?.('input[type="checkbox"],input[type="radio"],label,[data-tier-code],[data-value]'))) handler(); }, true);
  }

  function boot(){
    ensureBox(); wireUI(); attachDelegation();
    if (document.readyState!=='loading') syncPlacement();
    else document.addEventListener('DOMContentLoaded', syncPlacement);
  }
  boot();
})();
